import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeActionAction } from '../../reducers/actions';
import { ActionService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_ACTION),
    switchMap(action =>
      ActionService.delete(action.action, store).pipe(
        map(() => removeActionAction(action.action)),
        catchError(retryAuthentication(action$, 'epics/actions/deleteAction'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/actions/deleteAction.js